// Projection is presentation-only; never changes the actual KPI totals.
const weekday = date => new Date(`${date}T12:00:00Z`).getUTCDay()

const weekOfMonth = date => {
  const first = `${date.slice(0, 7)}-01`
  const mondayOffset = (weekday(first) + 6) % 7
  return Math.floor((Number(date.slice(8, 10)) - 1 + mondayOffset) / 7)
}

export function dailyProjection(series, today, enabled, pastMonths = [], { field = 'criados', precision = 0 } = {}) {
  const round = value => precision ? Math.round((value + Number.EPSILON) * 10 ** precision) / 10 ** precision : Math.floor(value)
  const month = today.slice(0, 7)
  const activeMonths = new Set(pastMonths.filter(day => day.bucket.slice(0, 7) < month && Number(day.criados) > 0).map(day => day.bucket.slice(0, 7)))
  const history = pastMonths.filter(day => activeMonths.has(day.bucket.slice(0, 7)))
  const usePreviousMonth = enabled && activeMonths.size > 0
  const referenceDays = new Map()
  for (const day of history) {
    const key = `${weekOfMonth(day.bucket)}-${weekday(day.bucket)}`
    const group = referenceDays.get(key) || { sum: 0, count: 0 }
    group.sum += Number(day[field] || 0)
    group.count++
    referenceDays.set(key, group)
  }
  const groups = Array.from({ length: 7 }, () => ({ sum: 0, count: 0 }))
  if (enabled) {
    for (const day of series) {
      if (!day.bucket.startsWith(month) || day.bucket >= today) continue
      const group = groups[weekday(day.bucket)]
      group.sum += Number(day[field] || 0)
      group.count++
    }
  }
  let projected = 0
  let forecastDays = 0
  let missingDays = 0
  const rows = series.map(day => {
    const future = enabled && day.bucket.startsWith(month) && day.bucket > today
    const group = groups[weekday(day.bucket)]
    const reference = usePreviousMonth ? referenceDays.get(`${weekOfMonth(day.bucket)}-${weekday(day.bucket)}`) : null
    const estimate = !future ? null : reference ? round(reference.sum / reference.count)
      : group.count ? round(group.sum / group.count) : null
    const forecastBasis = reference
      ? `Média do mesmo dia da semana e semana do mês em ${reference.count} mês(es) anterior(es) com dados.`
      : 'Média deste dia da semana no mês atual (sem referência nos meses anteriores), sem incluir hoje.'
    if (future && estimate === null) missingDays++
    if (estimate !== null) { projected += estimate; forecastDays++ }
    return { ...day, [field]: future ? null : day[field], previsto: estimate, forecastBasis: future ? forecastBasis : null }
  })
  const actual = series.filter(day => day.bucket.startsWith(month) && day.bucket <= today)
    .reduce((sum, day) => sum + Number(day[field] || 0), 0)
  return {
    rows,
    usePreviousMonth,
    hasForecast: forecastDays > 0,
    missingDays,
    projectedTotal: forecastDays > 0 && missingDays === 0 ? round(actual + projected) : null,
  }
}
